import { toggleSwitchDriverFactory as toggleSwitchCoreDriverFactory } from './ToggleSwitchCore/ToggleSwitchCore.driver';

const toggleSwitchDriverFactory = ({ element, eventTrigger }) => {
  const coreToggleSwitchDriver = toggleSwitchCoreDriverFactory({
    element,
    eventTrigger,
  });

  return {
    ...coreToggleSwitchDriver,
    /** Get Toggle Switch size */
    getSize: () => element.getAttribute('data-size'),

    /** Get Toggle Switch skin */
    getSkin: () => element.getAttribute('data-skin'),
  };
};

export default toggleSwitchDriverFactory;
